export default {
      id: "logo_chess_color-usage",
      viewBox: "0 0 119 30",
      url: __webpack_public_path__ + "sprite.svg#logo_chess_color",
      toString: function () {
        return this.url;
      }
    }